/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(
    [
        'jquery',
        'assets/js/modules/designFacePreview/designFacePreview',
        'assets/js/modules/designFacePreview/model/productPreviewInfoModel',
        'assets/js/modules/product/model/productModel',
        'assets/js/modules/option/optionModel',
        'assets/js/modules/product/model/attributeModel'
    ],
    function($, DesignFacePreview, ProductPreviewInfoModel, ProductModel, OptionModel, AttributeModel) {
        var optionNamesAffectingPreview = [OptionModel.NAME_CORNERS, OptionModel.NAME_FOLDING, OptionModel.NAME_SCORING];

        var FOLDING_PF = 'pf';

        return {
            /**
             * @param {ProductModel} product
             * @returns {ProductPreviewInfoModel}
             */
            getProductPreviewInfoFromProduct: function(product) {
                var bleedWidth = product.getAttributeValue(AttributeModel.NAME_FULLBLEED_WIDTH);
                var bleedHeight = product.getAttributeValue(AttributeModel.NAME_FULLBLEED_HEIGHT);
                var trimWidth = product.getAttributeValue(AttributeModel.NAME_NONBLEED_WIDTH);
                var trimHeight = product.getAttributeValue(AttributeModel.NAME_NONBLEED_HEIGHT);
                var safeWidth = product.getAttributeValue(AttributeModel.NAME_SAFEZONE_WIDTH);
                var safeHeight = product.getAttributeValue(AttributeModel.NAME_SAFEZONE_HEIGHT);
                var hasFoldLine = product.getAttributeValue(AttributeModel.NAME_FOLD_LINE) !== null;

                if (hasFoldLine) {
                    trimWidth *= 2;
                }

                var zones = {
                    bleedWidth: bleedWidth,
                    bleedHeight: bleedHeight,
                    safeWidth: safeWidth,
                    safeHeight: safeHeight,
                    trimWidth: trimWidth,
                    trimHeight: trimHeight
                };

                var shape = product.getAttributeValue(AttributeModel.NAME_SHAPE) || AttributeModel.VALUE_SHAPE_RECTANGULAR;
                var orientation = product.getAttributeValue(AttributeModel.NAME_ORIENTATION);

                var defaultOptions = {};
                product.get('options').each(function(option) {
                    if (optionNamesAffectingPreview.indexOf(option.get('name')) !== -1) {
                        option.get('optionValues').each(function(optionValue) {
                            if (optionValue.get('default')) {
                                defaultOptions[option.get('name')] = optionValue.get('name');
                            }
                        });
                    }
                });
                if (product.get('slug') === ProductModel.SLUG_PF) {
                    defaultOptions[OptionModel.NAME_FOLDING] = FOLDING_PF;
                }

                return new ProductPreviewInfoModel({
                    zones: zones,
                    shape: shape,
                    orientation: orientation,
                    hasFoldLine: hasFoldLine,
                    defaultOptions: defaultOptions
                });
            }
        };
    }
);
